import React, { useState, useRef } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
import { styles } from "../styles";
import { SectionWrapper } from "../hoc";
import { slideIn } from "./utils/motion";
import { EarthCanvas } from "./canvas";


const Contact = () => {
	const formRef = useRef();
	const [form, setForm] = useState({
		name: "",
		email: "",
		message: "",
	});

	const [loading, setLoading] = useState(false);
	const handleChange = (e) => {
		const { name, value } = e.target;
		setForm({ ...form, [name]: value });
	};
	const handleSubmit = (e) => {
		e.preventDefault();
		setLoading(true);

	
		emailjs
			.send(
				"service_qy0jojh",
				"template_cyr4p2v",
				{
					form_name: form.name,
					form_email: form.email,
					to_name: "maimohammed928@gmail.com",
					message: form.message,
				},
				"IScYUiAMopBjKLjsT",
			)
			.then(() => {
				setLoading(false);
				alert("Thank you . I will get back to you as soon as possible");
				setForm({
					name: "",
					email: "",
					message: "",
				});
			}, (error)=>{
         setLoading(false)
         console.log(error)
         alert('something went wrong')
      })
	};

	return (
		<div className="xl:mt-12 xl:flex-row flex-col-reverse flex gap-10 overflow-hidden ">
			<motion.div
				className="flex-[0.75] bg-black-100 p-8 rounded-2xl "
				variants={slideIn("left", "tween", 0.2, 1)}
			>
				<p className={styles.sectionSubText}>Get in touch</p>
				<h3 className={styles.sectionHeadText}>Contact</h3>

				<form
					className="mt-12 flex flex-col gap-8"
					ref={formRef}
					onSubmit={handleSubmit}
				>
					<label className="flex flex-col">
						<span className="text-white font-medium mb-4">Your Name </span>
						<input
							className="bg-tertiary py-4 px-6  placeholder:text-secondary text-white rounded-lg outline-none border-none font-medium "
							type="text"
							name="name"
							placeholder="What's your name ?"
							value={form.name}
							onChange={handleChange}
						/>
					</label>

					<label className="flex flex-col">
						<span className="text-white font-medium mb-4">Your Email </span>
						<input
							className="bg-tertiary py-4 px-6  placeholder:text-secondary text-white rounded-lg outline-none border-none font-medium "
							type="email"
							name="email"
							placeholder="Your Email"
							value={form.email}
							onChange={handleChange}
						/>
					</label>

					<label className="flex flex-col">
						<span className="text-white font-medium mb-4">Your Message </span>
						<textarea
							className="bg-tertiary py-4 px-6  placeholder:text-secondary text-white rounded-lg outline-none border-none font-medium "
							type="email"
							rows={7}
							name="message"
							placeholder="Your Message"
							value={form.message}
							onChange={handleChange}
						/>
					</label>
					<button
						className="bg-tertiary py-3 px-8 outline-none w-fit text-white font-bold shadow-primary rounded-xl"
						type="submit"
					>
						{loading ? "sending..." : "send"}
					</button>
				</form>
			</motion.div>

			<motion.div
				variants={slideIn("right", "tween", 0.2, 1)}
				className="xl:flex-1 xl:h-auto md:h-[550px] h-[350px]"
			>
				<EarthCanvas />
			</motion.div>
		</div>
	);
};

export default SectionWrapper(Contact, "contact");
